<template>
  <rabbey-table-4 :url="indexUrl" :columns="columns" />
</template>

<script>
import RabbeyTable4Vue from "@/components/RabbeyTable4.vue";

export default {
  name: "NavisionLicence",
  components: {
    "rabbey-table-4": RabbeyTable4Vue
  },
  data() {
    return {
      indexUrl: "/api/users/NavisionLicence",
      columns: [
        {
          prop: "SessionID",
          label: "ID de Session"
        },
        {
          prop: "ClientComputer",
          label: "Computadora"
        },
        {
          prop: "UserID",
          label: "ID del usuario"
        },
        {
          prop: "ClientType",
          label: "Tipo de cliente"
        },
        {
          prop: "LoginTime",
          label: "Tiempo de session"
        }
      ]
    };
  }
};
</script>
